import { render } from "./Notification.vue?vue&type=template&id=69ff6c13&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=69ff6c13&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69ff6c13"

export default script